<template>
  <p-dialog id="AVWAP" :visible.sync="visible" :closable="false" header="Anchored VWAP Settings" @hide="onClose" :modal="true">
    <div class="p-fluid">
      <div class="p-d-flex p-ai-center" style="margin-bottom: 1.5rem;">
        <label class="p-mr-3" style="min-width: 80px;">Source</label>
        <div style="flex-grow: 1;">
            <p-dropdown v-model="selectedSource" :options="sourceOptions" optionLabel="label" optionValue="value" appendTo="body" />
        </div>
      </div>

      <div class="bands-settings">
        <div class="p-d-flex p-flex-column" style="margin-bottom: 1.5rem; gap: 0.75rem;">
            <!-- Band 1 -->
            <div class="p-d-flex p-ai-center">
                <p-checkbox id="showBand1" v-model="showBand1" :binary="true" />
                <label for="showBand1" class="p-ml-2" style="min-width: 60px;">Band 1</label>
                <p-inputnumber v-model="band1Mult" class="p-ml-2" :min="0" :max="50" :minFractionDigits="1" :maxFractionDigits="2" mode="decimal" showButtons />
                <color-picker v-model="band1Color" class="p-ml-2" :isSettingsPicker="true" />
            </div>
            <!-- Band 2 -->
            <div class="p-d-flex p-ai-center">
                <p-checkbox id="showBand2" v-model="showBand2" :binary="true" />
                <label for="showBand2" class="p-ml-2" style="min-width: 60px;">Band 2</label>
                <p-inputnumber v-model="band2Mult" class="p-ml-2"  :min="0" :max="50" :minFractionDigits="1" :maxFractionDigits="2" mode="decimal" showButtons />
                <color-picker v-model="band2Color" class="p-ml-2" :isSettingsPicker="true" />
            </div>
            <!-- Band 3 -->
            <div class="p-d-flex p-ai-center">
                <p-checkbox id="showBand3" v-model="showBand3" :binary="true" />
                <label for="showBand3" class="p-ml-2" style="min-width: 60px;">Band 3</label>
                <p-inputnumber v-model="band3Mult" class="p-ml-2"  :min="0" :max="50" :minFractionDigits="1" :maxFractionDigits="2" mode="decimal" showButtons />
                <color-picker v-model="band3Color" class="p-ml-2" :isSettingsPicker="true" />
            </div>
        </div>
      </div>
    </div>
    <template #footer>
      <p-button label="OK" @click="ok" />
      <p-button label="Cancel" class="p-button-secondary" @click="onClose" />
    </template>
  </p-dialog>
</template>

<script>
import ColorPicker from '@/baseComponents/ColorPicker.vue'

export default {
  name: 'AnchoredVWAPSettings',
  components: {
    ColorPicker
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    getSettings: {
      type: Function,
      required: true
    },
    changeSettings: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      sourceOptions: [
        { label: 'HLC3', value: 'hlc3' },
        { label: 'Close', value: 'close' },
        { label: 'Open', value: 'open' },
        { label: 'High', value: 'high' },
        { label: 'Low', value: 'low' },
        { label: 'HL2', value: 'hl2' },
        { label: 'OHLC4', value: 'ohlc4' }
      ],
      initialSettings: {},
      isOk: false
    }
  },
  computed: {
    selectedSource: {
      get() { return this.getSettings('source') || 'hlc3' },
      set(val) { this.changeSettings({ source: val }) }
    },
    showBand1: {
      get() { return this.getSettings('showBand1') !== undefined ? this.getSettings('showBand1') : true },
      set(val) { this.changeSettings({ showBand1: val }) }
    },
    showBand2: {
      get() { return this.getSettings('showBand2') || false },
      set(val) { this.changeSettings({ showBand2: val }) }
    },
    showBand3: {
      get() { return this.getSettings('showBand3') || false },
      set(val) { this.changeSettings({ showBand3: val }) }
    },
    band1Mult: {
      get() { return this.getSettings('band1Mult') || 1.0 },
      set(val) { this.changeSettings({ band1Mult: val }) }
    },
    band2Mult: {
      get() { return this.getSettings('band2Mult') || 2.0 },
      set(val) { this.changeSettings({ band2Mult: val }) }
    },
    band3Mult: {
      get() { return this.getSettings('band3Mult') || 3.0 },
      set(val) { this.changeSettings({ band3Mult: val }) }
    },
    band1Color: {
      get() { return this.getSettings('band1Color') || 'rgba(41, 98, 255, 0.15)' },
      set(val) { this.changeSettings({ band1Color: val }) }
    },
    band2Color: {
      get() { return this.getSettings('band2Color') || 'rgba(41, 98, 255, 0.15)' },
      set(val) { this.changeSettings({ band2Color: val }) }
    },
    band3Color: {
      get() { return this.getSettings('band3Color') || 'rgba(41, 98, 255, 0.15)' },
      set(val) { this.changeSettings({ band3Color: val }) }
    }
  },
  watch: {
      visible(val) {
          if (val) {
              this.isOk = false
              // Backup initial settings to allow cancel
              this.initialSettings = {
                  source: this.getSettings('source'),
                  showBand1: this.getSettings('showBand1'),
                  showBand2: this.getSettings('showBand2'),
                  showBand3: this.getSettings('showBand3'),
                  band1Mult: this.getSettings('band1Mult'),
                  band2Mult: this.getSettings('band2Mult'),
                  band3Mult: this.getSettings('band3Mult'),
                  band1Color: this.getSettings('band1Color'),
                  band2Color: this.getSettings('band2Color'),
                  band3Color: this.getSettings('band3Color')
              }
          }
      }
  },
  methods: {
    onClose() {
      // Revert if cancelled
      if (!this.isOk) {
        this.changeSettings(this.initialSettings)
      }
      this.$emit('onClose')
    },
    ok() {
      this.isOk = true
      this.$emit('ok')
    }
  }
}
</script>

<style scoped>
/* .avwap-settings-dialog {
    width: 400px;
} */
.p-ai-center {
    align-items: center;
}
label {
    font-weight: 500;
}
:deep(.p-dialog#AVWAP) {
    width: 25rem !important;
}

</style>
